// Declare action names as constants with uppercase string

import ApiService from 'app/services/ApiService';
export const ATTACHMENT_BEGIN = 'ATTACHMENT_BEGIN';
export const ATTACHMENT_SUCCESS = 'ATTACHMENT_SUCCESS';
export const ATTACHMENT_FAILURE = 'ATTACHMENT_FAILURE';
export const ATTACHMENT_CLEAR = 'ATTACHMENT_CLEAR';

// Thunk: this is a special type of action that can dispatch other actions
export function fetchAttachment(data) {
    return async dispatch => {
        
        dispatch(attachmentBegin());
        await ApiService.getCourseAttachment(data)
            .then(
            result => {
                    dispatch(attachmentSuccess(result));
                },
            error => {
                dispatch(attachmentFailure(error));
                // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'Ops! the attach of this file has failed' });
                }
            )
    };
}

// Action: Function that returns an object with action data for reducer
export const attachmentBegin = () => ({
    type: ATTACHMENT_BEGIN
});
export const attachmentSuccess = data => ({
    type: ATTACHMENT_SUCCESS,
    payload: { data }
});
export const attachmentFailure = error => ({
    type: ATTACHMENT_FAILURE,
    payload: { error }
});

export const attachmentClear = () => ({
    type: ATTACHMENT_CLEAR,
});